<template>
    <div class="splash-screen">
      <img src="../assets/images/login.png" alt="App Logo">
      <div class="loading">Loading...</div>
    </div>
  </template>
  
  <script setup>
  import { onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  
  const router = useRouter()
  
  onMounted(() => {
    sessionStorage.setItem('hasSeenSplash', 'true')
    setTimeout(() => {
      router.replace('/')
    }, 3000) // 3秒后跳转到首页
  })
  </script>
  
  <style scoped>
  .splash-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    z-index: 9999;
  }
  
  .loading {
    margin-top: 20px;
  }
  </style>